// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","swmWrapper":"_1iYQbH3uaBst6NdFCPaF5t","swmFooter":"_1GgtC0xzZQQzbAu2V3qKPJ"};